module.exports = __webpack_public_path__ + "static/media/mohamed-doudi.0ffcbb1c.jpeg";